export function stripCodeFence(text) {
  return text.replace(/^```json\n|\n```$/g, "");
}

// LLMs asked to return HTML inside a JSON string sometimes include raw
// newlines/tabs/control characters instead of escaping them, which breaks
// strict JSON.parse ("Bad control character in string literal"). This walks
// the text tracking whether we're inside a string literal (respecting
// backslash escapes) and escapes any raw control character found there.
function escapeRawControlChars(text) {
  let result = "";
  let inString = false;
  let escapeNext = false;

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    const code = text.charCodeAt(i);

    if (escapeNext) {
      result += ch;
      escapeNext = false;
      continue;
    }

    if (ch === "\\" && inString) {
      result += ch;
      escapeNext = true;
      continue;
    }

    if (ch === '"') {
      inString = !inString;
      result += ch;
      continue;
    }

    if (inString && code < 0x20) {
      if (ch === "\n") result += "\\n";
      else if (ch === "\r") result += "\\r";
      else if (ch === "\t") result += "\\t";
      else result += "\\u" + code.toString(16).padStart(4, "0");
      continue;
    }

    result += ch;
  }

  return result;
}

// Strips ```json fences and repairs unescaped control characters before
// parsing, so a slightly-malformed LLM response doesn't crash the caller.
export function parseAiJson(rawText) {
  const stripped = stripCodeFence(rawText);
  const sanitized = escapeRawControlChars(stripped);
  return JSON.parse(sanitized);
}
